"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _fi = require("react-icons/fi"); // There are several icons in the component
// Brought out separately, so that there is less duplication


var iconProps = {
  normal: {
    category: 'fi',
    defaultIcon: _fi.FiMenu,
    size: '24px',
    color: '--dark'
  },
  closed: {
    category: 'fi',
    defaultIcon: _fi.FiMenu
  },
  open: {
    category: 'fi',
    defaultIcon: _fi.FiX
  }
};
var overrides = {
  Button: {
    kind: 'Box'
  },
  'Button Text': {
    kind: 'Text',
    props: {
      children: 'menu'
    }
  },
  'Button Icon': {
    kind: 'Icon',
    props: iconProps.normal
  },
  'Button Icon :open': {
    kind: 'Icon',
    props: iconProps.open
  },
  'Button Icon :closed': {
    kind: 'Icon',
    props: iconProps.closed
  },
  Wrapper: {
    kind: 'Box'
  },
  Overlay: {
    kind: 'Box'
  },
  Content: {
    kind: 'Box'
  },
  Children: {
    kind: 'Box'
  },
  Cross: {
    kind: 'Icon',
    props: iconProps.open
  }
};
var _default = overrides;
exports["default"] = _default;